
<template>
    <div>
<b-card no-body>
    <v-table    ref="table"
                :items-provider="provider"
                pagination="server"
                search
                :initial-per-page="100"
                :fields="fields"
                :buttons="buttons"
                button-alignment="justify-content-end">
                
                </v-table>
</b-card>
    </div>
</template>
<script>
import NetsisOperationsApi from '@/api/netsis-operations'
import { BCard } from 'bootstrap-vue'
import { printFis } from './components/fis/print-fis';
import { printFaturaFis } from './components/fis/print-fatura-fis';
import { printTediyeFis } from './components/fis/print-tediye-fis';

export default{

    components:{
        BCard,
    },
    data(){
        return {
            
            fields:[
                { name:'Tarih',key:'TARIHStr',thClass:'w-8', tdClass:'text-nowrap'},
                { name:'Tip',key:'TIP',thClass:'w-8', tdClass:'text-nowrap'},
                { name:'Kod',key:'KOD',thClass:'w-8', tdClass:'text-nowrap', tdClass:'text-nowrap'},
                { name:'Proje Kodu',key:'PROJE_KODU',thClass:'w-8', tdClass:'text-nowrap', tdClass:'text-nowrap'},
                { name:'Muh. Adı', key:'MUH_ADI', tdClass:'text-nowrap',thClass:'w-10'},
                { name:'Cari/Muh',key:'CARI_MUH', tdClass:'text-nowrap',thClass:'w-8'},
                { name:'Açıklama',key:'ACIKLAMA',thClass:'w-8', tdClass:'text-nowrap'},
                { name:'TMS Açıklama',key:'TMSVaultDescription',thClass:'w-8', tdClass:'text-nowrap'},
                { name:'Cari Adı',key:'CARI_ISIM',thClass:'w-10', tdClass:'text-nowrap '},
                { name:'Tahsil',key:'Tahsil',thClass:'w-8', tdClass:'text-nowrap'},
                { name:'Tediye',key:'Tediye',thClass:'w-8', tdClass:'text-nowrap'},
                { name:'Plasiyer Adı',key:'PLASIYER_ISIM',thClass:'w-8', tdClass:'text-nowrap'},
                { name:'Kasa Kodu',key:'KSMAS_KOD', tdClass:'text-nowrap',thClass:'w-8'},
                { name:'Tutar',key:'TUTAR', tdClass:'text-nowrap text-right',thClass:'w-8', tdClass:'text-nowrap text-right'},
            ],
            buttons:[
                { text:"Fiş Yazdır",key:"fis",icon:"PrinterIcon",variant:"primary",action:this.print},
                { text:"Yevmiye Fişi Yazdır",key:"ted-fis",icon:"PrinterIcon",variant:"secondary",action:this.printTediye },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.deleteHareket },
            ],
        }
    },
    methods:{
        provider(data){
            return NetsisOperationsApi.GetKasaHareketleri({
                KasaKod:null,
                StartDate:null,
                EndDate:null,
                GirisCikis:null,
                ActionType:null,
                CariCode:null,
                MuhasebePlanCode:null,
                PlasiyerCode:null,
                SubeKodu:null,
                ProjeKodu:null,
                PaginationRequestModel:data
            })
        },
        printTediye(i){
            if(i.FIS_NO && i.TIP && i.SIRA){
                this.$refs.table.rowLoading(true)
                NetsisOperationsApi.TediyeFis(i.FIS_NO,i.TIP,i.SIRA).then(res => {
                    this.$refs.table.rowLoading(false)
                    if(res.data.Success){
                        printTediyeFis(res.data.Data)
                    }else{
                        this.$result(res)
                    }
                }).catch(err => {
                    this.$refs.table.rowLoading(false)
                    this.$result(null,err)
                })
            }
        },
        print(i){
            if(i.FIS_NO){
                let api = null
                if(i.TIP == 'C') api = NetsisOperationsApi.CariFis
                else if(i.TIP == 'B') api = NetsisOperationsApi.BankaFis
                else if(i.TIP == 'M') api = NetsisOperationsApi.MuhtelifFis
                else if(i.TIP == 'F') api = NetsisOperationsApi.FaturaFisTediye
                if(api){
                  api(i.FIS_NO,i.SIRA).then(res => {
                    if(res.data.Success){
                      printFis(res.data.Data)
                    }else{
                      this.$result(res)
                    }
                  }).catch(err => {
                      this.$result(null,err)
                  })
             }
        }
        },
        deleteHareket(i){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${i.SIRA} sıra numaralı işlemi silecektir ve geri alınamaz.`)
            .then(c => {
                if(c){
                    NetsisOperationsApi.DeleteKasaHareket(i.SIRA).then(res => {
                        this.$result(res)
                        if(res.data.Success){
                            this.$refs.table.refresh()
                        }
                    })
                }
            }).catch(err => {
                this.$result(null,err)
            })
        }
    }
}
</script>